<template>
  <Guide :titleList="titleList">
    <template #innerContent>
      <div style="width: 100%;height: 50px;margin-top: 30px">
      </div>
      <h1>{{ $t('guide.home.title') }}</h1>
      <div>{{ $t('guide.home.des') }}</div>
      <br>
      <div>{{ $t('guide.home.message') }}</div>
      <div id="part1" style="margin-top: 30px;">
        <CollapseItem :title="$t('guide.home.part.1')" :level="1" v-model:visible="isShow1">
          <div id="part_child_1_1">
            <CollapseItem :title="$t('guide.home.part.1.1')" :level="2" v-model:visible="isShow1_1">
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.1.txt.1') }}<span
                  class="w700">{{ $t('guide.part.1.txt.2') }}</span>{{ $t('guide.part.1.txt.3') }}<span
                  class="w700">{{ $t('guide.part.1.txt.4') }}</span></div>
              <br>
              <ImageShow :url="docImg1"/>
              <br>
              <div>{{ $t('guide.part.1.txt.5') }}</div>
              <br>
              <div>{{ $t('guide.part.1.txt.6') }}</div>
              <br>
              <div>
                {{ $t('guide.part.1.txt.7') }}
              </div>
              <br>
              <div>
                <span class="w700 red">{{ $t('guide.part.tip') }}</span>{{ $t('guide.part.1.txt.8') }}
              </div>
              <br>
              <br>
              <div class="step w700">{{ $t('guide.part.1.txt.9') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.1.txt.10') }}<span
                  class="w700">{{ $t('guide.part.1.txt.11') }}</span>{{ $t('guide.part.1.txt.12') }}
              </div>
              <br>
              <div>{{ $t('guide.part.1.txt.13') }}<span
                  class="w700">{{ $t('guide.part.1.txt.14') }}</span>{{ $t('guide.part.1.txt.15') }}
              </div>
              <br>
              <ImageShow :url="docImg2"/>
              <br>
              <ImageShow :url="docImg3"/>
              <br>
              <div>{{ $t("guide.part.1.txt.16") }}<span
                  class="w700">{{ $t('guide.part.1.txt.17') }}</span>{{ $t('guide.part.1.txt.18') }}
              </div>
              <br>
              <div>
                {{ $t('guide.part.1.txt.13') }}<span
                  class="w700">{{ $t('guide.part.1.txt.19') }}</span>{{ $t('guide.part.1.txt.20') }}<span class="w700">{{
                  $t('guide.part.1.txt.21')
                }}</span>{{ $t('guide.part.1.txt.22') }}
              </div>
              <br>
              <ImageShow :url="docImg4"/>
              <br>
              <ImageShow :url="docImg5"/>
              <br>
              <div><span class="w700 red">{{ $t('guide.part.tip') }}</span>{{ $t('guide.part.1.txt.23') }}
              </div>
              <br>
              <ImageShow :url="docImg6"/>
              <br>
              <ImageShow :url="docImg7"/>
              <br>
              <div><span class="w700 red">{{ $t('guide.part.tip') }}</span>{{ $t('guide.part.1.txt.24') }}
              </div>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_1_2">
            <CollapseItem :title="$t('guide.home.part.1.2')" :level="2" v-model:visible="isShow1_2">
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt.25') }}</div>
              <br>
              <br>
              <div><span class="w700">{{ $t('guide.part.1.txt.26') }}</span>{{ $t('guide.part.1.txt.27') }}</div>
              <br>
              <ImageShow :url="docImg8"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt.28') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.1.txt.29') }}<span
                  class="w700">{{ $t('guide.part.1.txt.30') }}</span>{{ $t('guide.part.1.txt.31') }}
              </div>
              <br>
              <ImageShow :url="docImg9"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt.32') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.1.txt.33') }}</div>
              <br>
              <ImageShow :url="docImg10"/>
              <br>
              <div class="red">{{ $t('guide.part.1.txt.34') }}</div>
            </CollapseItem>
          </div>
          <div id="part_child_1_3">
            <CollapseItem :title="$t('guide.home.part.1.3')" :level="2" v-model:visible="isShow1_3">
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt.35') }}</div>
              <br>
              <br>
              <div><span class="w700">{{ $t('guide.part.1.txt.36') }}</span>{{ $t('guide.part.1.txt.37') }}
              </div>
              <br>
              <ImageShow :url="docImg11"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt.38') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.1.txt.39') }}<span
                  class="w700">{{ $t('guide.part.1.txt.17') }}</span>{{ $t('guide.part.1.txt.40') }}
              </div>
              <br>
              <ImageShow :url="docImg12"/>
              <br>
              <div>{{ $t('guide.part.1.txt.41') }}</div>
              <br>
              <video
                  :src="require('@/assets/video/10431_1758004157.mp4')"
                  controls
                  style="width: 100%; height: 400px; object-fit: cover; border-radius: 6px; border: 1px solid #e7e9e8;"
              ></video>
            </CollapseItem>
          </div>
          <div id="part_child_1_4">
            <CollapseItem :title="$t('guide.home.part.1.4')" :level="2" v-model:visible="isShow1_4">
              <br>
              <div>{{ $t('guide.part.1.txt.42') }}</div>
              <br>
              <div>
                {{ $t('guide.part.1.txt.43') }}
              </div>
              <br>
              <div>{{ $t('guide.part.1.txt.44') }}</div>
              <br>
              <ImageShow :url="docImg13"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt.45') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.1.txt.46') }}</div>
              <br>
              <ImageShow :url="docImg14"/>
              <br>
              <ImageShow :url="docImg15"/>
              <br>
              <div>{{ $t('guide.part.1.txt.47') }}</div>
              <br>
              <ImageShow :url="docImg16"/>
              <br>
              <ImageShow :url="docImg17"/>
              <br>
              <ImageShow :url="docImg18"/>
              <br>
              <div>{{ $t('guide.part.1.txt.48') }}<span
                  class="w700">{{ $t('guide.part.1.txt.49') }}</span>{{ $t('guide.part.1.txt.50') }}
              </div>
              <br>
              <ImageShow :url="docImg19"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt.51') }}</div>
              <br>
              <br>
              <div><span class="w700">{{ $t('guide.part.1.txt.52') }}</span>{{ $t('guide.part.1.txt.53') }}</div>
              <br>
              <ImageShow :url="docImg20"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.1.txt.54') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.1.txt.55') }}</div>
              <br>
              <div>{{ $t('guide.part.1.txt.56') }}</div>
              <br>
              <ImageShow :url="docImg21"/>
              <br>
              <ImageShow :url="docImg22"/>
              <br>
              <ImageShow :url="docImg23"/>
              <br>
              <ImageShow :url="docImg24"/>
              <br>
              <div>{{ $t('guide.part.1.txt.57') }}</div>
              <br>
              <video
                  :src="require('@/assets/video/10433_1758004177.mp4')"
                  controls
                  style="width: 100%; height: 400px; object-fit: cover; border-radius: 6px; border: 1px solid #e7e9e8;"
              ></video>
              <br>
              <br>
              <div>{{ $t('guide.part.1.txt.58') }}</div>
              <br>
              <div>
                {{ $t('guide.part.1.txt.59') }}
              </div>
              <br>
              <ImageShow :url="docImg25"/>
              <br>
              <ImageShow :url="docImg26"/>
              <br>
              <br>
              <br>
            </CollapseItem>
          </div>
        </CollapseItem>
      </div>
      <div id="part2" style="margin-top: 30px;">
        <CollapseItem :title="$t('guide.home.part.2')" :level="1" v-model:visible="isShow2">
          <div id="part_child_2_1">
            <CollapseItem :title="$t('guide.home.part.2.1')" :level="2" v-model:visible="isShow2_1">
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.2.txt.1') }}</div>
              <br>
              <br>
              <div class="w700">{{ $t('guide.part.2.txt.2') }}</div>
              <br>
              <ImageShow :url="docImg27"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.2.txt.3') }}</div>
              <br>
              <br>
              <div>
                {{ $t('guide.part.2.txt.4') }}
              </div>
              <br>
              <ImageShow :url="docImg28"/>
              <br>
              <div><span class="w700 red">{{ $t('guide.part.2.txt.5') }}</span>{{ $t('guide.part.2.txt.6') }}
              </div>
              <br>
              <div>{{ $t('guide.part.2.txt.7') }}</div>
              <ImageShow :url="docImg29"/>
              <div>{{ $t('guide.part.2.txt.8') }}</div>
              <ImageShow :url="docImg30"/>
              <div>{{ $t('guide.part.2.txt.9') }}</div>
              <ImageShow :url="docImg31"/>
              <br>
              <div><span class="w700 red">{{ $t('guide.part.2.txt.10') }}</span><span
                  class="w700">{{ $t('guide.part.2.txt.11') }}</span>{{ $t('guide.part.2.txt.12') }}<span class="w700">{{
                  $t('guide.part.2.txt.13')
                }}</span>{{ $t('guide.part.2.txt.14') }}<span
                  class="w700">{{ $t('guide.text.email.text.17') }}</span>{{ $t('guide.part.2.txt.15') }}
              </div>
              <br>
              <ImageShow :url="docImg32"/>
              <br>
              <ImageShow :url="docImg33"/>
              <br>
              <div><span class="w700 red">{{ $t('guide.part.2.txt.16') }}</span>{{ $t('guide.part.2.txt.17') }}<span
                  class="w700">{{ $t('guide.part.2.txt.18') }}</span>{{ $t('guide.part.2.txt.19') }}
              </div>
              <br>
              <ImageShow :url="docImg34"/>
              <br>
              <ImageShow :url="docImg35"/>
              <br>
              <div>{{ $t('guide.part.2.txt.20') }}<span
                  class="w700">{{ $t('guide.part.2.txt.21') }}</span>{{ $t('guide.part.2.txt.22') }}
              </div>
              <br>
              <ImageShow :url="docImg36"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.2.txt.23') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.2.txt.24') }}<span
                  class="w700">{{ $t('guide.part.2.txt.25') }}</span>{{ $t('guide.part.2.txt.26') }}
              </div>
              <br>
              <ImageShow :url="docImg37"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.2.txt.27') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.2.txt.28') }}</div>
              <br>
              <div>{{ $t('guide.part.2.txt.29') }}</div>
              <br>
              <ImageShow :url="docImg38"/>
              <br>
              <ImageShow :url="docImg39"/>
              <br>
              <div><span class="w700">{{ $t('guide.part.2.txt.30') }}</span>{{ $t('guide.part.2.txt.31') }}
              </div>
              <br>
              <ImageShow :url="docImg40"/>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_2_2">
            <CollapseItem :title="$t('guide.home.part.2.2')" :level="2" v-model:visible="isShow2_2">
              <br>
              <div>{{ $t('guide.part.2.txt.32') }}<span
                  class="w700">{{ $t('guide.part.2.txt.33') }}</span>{{ $t('guide.part.2.txt.34') }}
              </div>
              <br>
              <div>{{ $t('guide.part.2.txt.35') }}<span
                  class="w700">{{ $t("guide.part.2.txt.36") }}</span>{{ $t("guide.part.2.txt.37") }}<span
                  class="w700">{{ $t('guide.part.2.txt.38') }}</span>{{ $t('guide.part.2.txt.39') }}<span class="w700">{{
                  $t('guide.part.2.txt.40')
                }}</span>
              </div>
              <br>
              <ImageShow :url="docImg41"/>
              <br>
              <div><span class="red w700">{{ $t('guide.part.2.txt.5') }}</span>{{ $t('guide.part.2.txt.41') }}
              </div>
              <br>
              <div><span class="red w700">{{ $t('guide.part.2.txt.10') }}</span>{{ $t('guide.part.2.txt.42') }}
              </div>
              <br>
              <div><span class="red w700">{{ $t('guide.part.2.txt.16') }}</span>{{ $t('guide.part.2.txt.43') }}
              </div>
              <br>
              <div><span class="red w700">{{ $t('guide.part.2.txt.44') }}</span>{{ $t('guide.part.2.txt.45') }}
              </div>
              <br>
              <ImageShow :url="docImg42"/>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_2_3">
            <CollapseItem :title="$t('guide.home.part.2.3')" :level="2" v-model:visible="isShow2_3">
              <br>
              <div>{{ $t('guide.part.2.txt.46') }}<span
                  class="w700">{{ $t('guide.part.2.txt.47') }}</span>{{ $t('guide.part.2.txt.48') }}<span
                  class="w700">{{ $t('guide.part.2.txt.49') }}</span>{{ $t('guide.part.2.txt.50') }}
              </div>
              <br>
              <ImageShow :url="docImg43"/>
              <br>
              <ImageShow :url="docImg44"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.2.txt.51') }}</div>
              <br>
              <br>
              <ImageShow :url="docImg45"/>
              <br>
              <div><span class="w700">{{ $t('guide.part.2.txt.52') }}</span>{{ $t('guide.part.2.txt.53') }}</div>
              <br>
              <div><span class="w700">{{ $t('guide.part.2.txt.54') }}</span>{{ $t('guide.part.2.txt.55') }}<span
                  class="w700">{{ $t('guide.part.2.txt.56') }}</span>{{ $t('guide.part.2.txt.57') }}
              </div>
              <br>
              <ImageShow :url="docImg46"/>
              <br>
              <div><span class="w700">{{ $t('guide.part.2.txt.58') }}</span>{{ $t('guide.part.2.txt.59') }}</div>
              <br>
              <div><span class="w700">{{ $t('guide.part.2.txt.60') }}</span>{{ $t('guide.part.2.txt.61') }}
              </div>
              <br>
              <ImageShow :url="docImg47"/>
              <br>
              <div><span class="w700">{{ $t('guide.part.2.txt.62') }}</span>{{ $t('guide.part.2.txt.63') }}
              </div>
              <br>
              <div><span class="w700">{{ $t('guide.part.2.txt.64') }}</span>{{ $t('guide.part.2.txt.65') }}<span
                  class="w700">{{ $t('guide.part.2.txt.66') }}</span>{{ $t('guide.part.2.txt.67') }}
              </div>
              <br>
              <div><span class="w700">{{ $t('guide.part.2.txt.68') }}</span>{{ $t('guide.part.2.txt.69') }}<span
                  class="w700">{{ $t("guide.part.2.txt.70") }}</span>{{ $t('guide.part.2.txt.71') }}
              </div>
              <br>
              <ImageShow :url="docImg48"/>
              <br>
              <ImageShow :url="docImg49"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.2.txt.72') }}</div>
              <br>
              <br>
              <ImageShow :url="docImg50"/>
              <br>
              <div>{{ $t('guide.part.2.txt.73') }}<span
                  class="w700">{{ $t('guide.part.2.txt.74') }}</span>{{ $t('guide.part.2.txt.75') }}
              </div>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.2.txt.76') }}</div>
              <br>
              <br>
              <ImageShow :url="docImg51"/>
              <br>
              <div>{{ $t('guide.part.2.txt.77') }}<span
                  class="w700">{{ $t('guide.part.2.txt.78') }}</span>{{ $t('guide.part.2.txt.79') }}
              </div>
              <br>
              <ImageShow :url="docImg52"/>
              <br>
              <ImageShow :url="docImg53"/>
              <br>
              <ImageShow :url="docImg54"/>
              <br>
              <ImageShow :url="docImg55"/>
              <br>
              <ImageShow :url="docImg56"/>
              <br>
              <br>
              <br>
              <div class="step w700 ">{{ $t('guide.part.2.txt.80') }}</div>
              <br>
              <br>
              <div>{{ $t('guide.part.2.txt.81') }}</div>
              <br>
              <div>{{ $t("guide.part.2.txt.82") }}<span
                  class="w700">{{ $t('guide.part.2.txt.83') }}</span>{{ $t('guide.part.2.txt.84') }}
              </div>
              <br>
              <ImageShow :url="docImg57"/>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_2_4">
            <CollapseItem :title="$t('guide.home.part.2.4')" :level="2" v-model:visible="isShow2_4">
              <br>
              <div>{{ $t('guide.part.2.txt.85') }}</div>
              <br>
              <ImageShow :url="docImg58"/>
              <br>
              <div><span class="w700">{{ $t('g.p2.t.1') }}</span>{{ $t('g.p2.t.2') }}
              </div>
              <br>
              <div><span class="w700">{{ $t('g.p2.t.3') }}</span>{{ $t('g.p2.t.4') }}
              </div>
              <br>
              <div><span class="w700">{{ $t('g.p2.t.5') }}</span>{{ $t('g.p2.t.6') }}
                <span class="w700">{{ $t('g.p2.t.7') }}</span>{{ $t('g.p2.t.8') }}
                <span class="w700">{{ $t('g.p2.t.9') }}</span>{{ $t('g.p2.t.10') }}
              </div>
              <br>
              <div><span class="w700">{{ $t('g.p2.t.11') }}</span>{{ $t('g.p2.t.12') }}</div>
              <br>
              <div><span class="w700">{{ $t('g.p2.t.13') }}</span>{{ $t('g.p2.t.14') }}<span
                  class="w700">{{ $t('g.p2.t.15') }}</span>{{ $t('g.p2.t.16') }}<span
                  class="w700">{{ $t('g.p2.t.17') }}</span>{{ $t('g.p2.t.18') }}
              </div>
              <br>
              <ImageShow :url="docImg59"/>
              <br>
              <div>
                <span class="w700">{{ $t('g.p2.t.19') }}</span>
                {{ $t('g.p2.t.20') }}
              </div>
              <br>
              <ImageShow :url="docImg60"/>
              <br>
              <div><span class="w700">{{ $t('g.p2.t.21') }}</span>{{ $t('g.p2.t.22') }}
              </div>
              <br>
              <ImageShow :url="docImg61"/>
              <br>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_2_5">
            <CollapseItem :title="$t('guide.home.part.2.5')" :level="2" v-model:visible="isShow2_5">
              <br>
              <div><span class="w700">{{ $t('g.p2.t.23') }}</span>{{ $t('g.p2.t.24') }}
              </div>
              <br>
              <ImageShow :url="docImg62"/>
              <br>
              <ImageShow :url="docImg63"/>
              <br>
              <div><span class="w700">{{ $t('g.p2.t.25') }}</span>{{ $t('g.p2.t.26') }}
              </div>
              <br>
              <ImageShow :url="docImg64"/>
              <br>
              <ImageShow :url="docImg65"/>
              <br>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_2_6">
            <CollapseItem :title="$t('guide.home.part.2.6')" :level="2" v-model:visible="isShow2_6">
              <br>
              <div>{{ $t('g.p2.t.27') }} <span class="w700">{{ $t('g.p2.t.28') }}</span> {{ $t('g.p2.t.29') }}</div>
              <br>
            </CollapseItem>
          </div>
        </CollapseItem>
      </div>
      <div id="part3" style="margin-top: 30px;">
        <CollapseItem :title="$t('guide.home.part.3')" :level="1" v-model:visible="isShow3">
          <br>
          <div>{{ $t('g.p3.t.1') }}</div>
          <br>
          <div id="part_child_3_1">
            <CollapseItem :title="$t('guide.home.part.3.1')" :level="2" v-model:visible="isShow3_1">
              <br>
              <div>{{ $t('g.p3.t.2') }}</div>
              <br>
              <div>{{ $t('g.p3.t.3') }}</div>
              <br>
              <ImageShow :url="docImg66"/>
              <br>
              <div>{{ $t('g.p3.t.4') }}<span class="w700">{{ $t('g.p3.t.5') }}</span>{{ $t("g.p3.t.6") }}<span
                  class="w700">{{ $t('g.p3.t.7') }}</span>{{ $t('g.p3.t.8') }}<span
                  class="w700">{{ $t('g.p3.t.9') }}</span>{{ $t('g.p3.t.10') }}
              </div>
              <br>
              <ImageShow :url="docImg67"/>
              <br>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_3_2">
            <CollapseItem :title="$t('guide.home.part.3.2')" :level="2" v-model:visible="isShow3_2">
              <br>
              <div>{{ $t('g.p3.t.11') }}</div>
              <br>
              <div><span class="w700">{{ $t('g.p3.t.12') }}</span>{{ $t('g.p3.t.13') }}</div>
              <br>
              <ImageShow :url="docImg68"/>
              <br>
              <div><span class="w700">{{ $t('g.p3.t.14') }}</span>{{ $t('g.p3.t.15') }}
              </div>
              <br>
              <ImageShow :url="docImg69"/>
              <br>
              <div><span class="w700">{{ $t('g.p3.t.16') }}</span>{{ $t('g.p3.t.17') }}</div>
              <br>
              <ImageShow :url="docImg70"/>
              <br>
              <div><span class="w700">{{ $t('g.p3.t.18') }}</span>{{ $t('g.p3.t.19') }}</div>
              <br>
              <ImageShow :url="docImg71"/>
              <br>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_3_3">
            <CollapseItem :title="$t('guide.home.part.3.3')" :level="2" v-model:visible="isShow3_3">
              <br>
              <div>{{ $t('g.p3.t.20') }}<span class="w700 red">{{ $t('g.p3.t.21') }}</span>{{ $t('g.p3.t.22') }}
              </div>
              <br>
              <br>
              <div class="w700 step">{{ $t('g.p3.t.23') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.24') }}</div>
              <br>
              <ImageShow :url="docImg72"/>
              <br>
              <ImageShow :url="docImg73"/>
              <br>
              <div><span class="red w700">{{ $t('guide.part.2.txt.5') }}</span>{{ $t('g.p3.t.25') }}
              </div>
              <br>
              <div>
                <span class="red w700">{{ $t('guide.part.2.txt.10') }}</span>{{ $t('g.p3.t.26') }}<span
                  class="w700">{{ $t('g.p3.t.27') }}</span>{{ $t('g.p3.t.28') }}<span
                  class="w700">{{ $t("g.p3.t.29") }}</span>{{ $t('g.p3.t.30') }}
              </div>
              <br>
              <div>
                <span class="w700 red">{{ $t('guide.part.2.txt.16') }}</span>{{ $t('g.p3.t.31') }}
              </div>
              <br>
              <div>
                <span class="w700 red">{{ $t('guide.part.2.txt.44') }}</span>{{ $t('g.p3.t.32') }}<span
                  class="w700">{{ $t('g.p3.t.33') }}</span>{{ $t('g.p3.t.34') }}
              </div>
              <br>
              <br>
              <br>
              <div class="w700 step">{{ $t('g.p3.t.35') }}</div>
              <br>
              <br>
              <div class="w700">{{ $t('g.p3.t.36') }}</div>
              <br>
              <ImageShow :url="docImg74"/>
              <br>
              <ImageShow :url="docImg75"/>
              <br>
              <ImageShow :url="docImg76"/>
              <br>
              <ImageShow :url="docImg77"/>
              <br>
              <div><span class="w700 red">{{ $t('guide.part.2.txt.5') }}</span>{{ $t('g.p3.t.37') }}
              </div>
              <br>
              <div><span class="w700 red">{{ $t('guide.part.2.txt.10') }}</span>{{ $t('g.p3.t.38') }}
              </div>
              <br>
              <div><span class="w700 red">{{ $t('guide.part.2.txt.16') }}</span>{{ $t('g.p3.t.39') }}
              </div>
              <br>
              <div><span class="w700 red">{{ $t('guide.part.2.txt.44') }}</span>{{ $t('g.p3.t.40') }}
              </div>
              <br>
              <div><span class="w700 red">{{ $t('g.p3.t.41') }}</span>{{ $t('g.p3.t.42') }}
              </div>
              <br>
              <div><span class="w700 red">{{ $t('g.p3.t.43') }}</span>{{ $t('g.p3.t.44') }}
              </div>
              <br>
              <div><span class="w700 red">{{ $t('g.p3.t.45') }}</span>{{ $t('g.p3.t.46') }}
              </div>
              <br>
              <div><span class="w700 red">{{ $t('g.p3.t.47') }}</span>{{ $t('g.p3.t.48') }}
              </div>
              <br>
              <br>
              <br>
              <div class="w700 step">{{ $t('g.p3.t.49') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.50') }}<span class="w700">{{ $t('g.p3.t.51') }}</span>{{ $t('g.p3.t.52') }}
              </div>
              <br>
              <ImageShow :url="docImg78"/>
              <br>
              <ImageShow :url="docImg79"/>
              <br>
              <br>
              <video
                  :src="require('@/assets/video/10434_1758004197.mp4')"
                  controls
                  style="width: 100%; height: 400px; object-fit: cover; border-radius: 6px; border: 1px solid #e7e9e8;"
              ></video>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_3_4">
            <CollapseItem :title="$t('guide.home.part.3.4')" :level="2" v-model:visible="isShow3_4">
              <br>
              <div>{{ $t('g.p3.t.53') }}<span class="w700">{{ $t('g.p3.t.54') }}</span>{{ $t('g.p3.t.55') }}</div>
              <br>
              <div>{{ $t('g.p3.t.56') }}<span class="w700">{{ $t('g.p3.t.57') }}</span>{{ $t('g.p3.t.58') }}
              </div>
              <br>
              <ImageShow :url="docImg80"/>
              <br>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_3_5">
            <CollapseItem :title="$t('guide.home.part.3.5')" :level="2" v-model:visible="isShow3_5">
              <br>
              <div><span class="w700">{{ $t('g.p3.t.59') }}</span>{{ $t('g.p3.t.60') }}</div>
              <br>
              <ImageShow :url="docImg81"/>
              <br>
              <ImageShow :url="docImg82"/>
              <br>
              <div>
                <span class="w700">{{ $t('g.p3.t.61') }}</span>{{ $t('g.p3.t.62') }}<span
                  class="w700">{{ $t('g.p3.t.63') }}</span>{{ $t('g.p3.t.64') }}
              </div>
              <br>
              <ImageShow :url="docImg83"/>
              <br>
              <ImageShow :url="docImg84"/>
              <br>
              <br>
              <div>
                <span class="w700">{{ $t('g.p3.t.add.new') }}</span>{{ $t('g.p3.t.add.new.txt.1') }}
              </div>
              <br>
              <ImageShow :url="customerTag1"/>
              <ImageShow :url="customerTag2"/>
              <br>
              <div>{{ $t("g.p3.t.add.new.txt.2") }}</div>
              <br>
              <ImageShow :url="customerTag3"/>
              <br>
              <br>
              <div><span class="w700">{{ $t('g.p3.t.65') }}</span>{{ $t('g.p3.t.66') }}</div>
              <br>
              <ImageShow :url="docImg85"/>
              <br>
              <div>
                <span class="w700">{{ $t('g.p3.t.67') }}</span>{{ $t('g.p3.t.68') }}<span
                  class="w700">{{ $t('g.p3.t.69') }}</span>{{ $t('g.p3.t.70') }}
              </div>
              <ImageShow :url="docImg86"/>
              <br>
              <ImageShow :url="docImg87"/>
              <br>
              <br>
              <div><span class="w700">{{ $t('g.p3.t.73') }}</span>{{ $t('g.p3.t.74') }}
              </div>
              <br>
              <ImageShow :url="docImg89"/>
              <br>
              <div><span class="w700">{{ $t('g.p3.t.75') }}</span>{{ $t('g.p3.t.76') }}
              </div>
              <br>
              <ImageShow :url="docImg90"/>
              <br>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_3_6">
            <CollapseItem :title="$t('guide.home.part.3.6')" :level="2" v-model:visible="isShow3_6">
              <br>
              <br>
              <div class="step" style="font-weight: 500;">{{ $t('g.p3.t.77') }}</div>
              <br>
              <br>
              <div><span class="w700">{{ $t('g.p3.t.78') }}</span>{{ $t('g.p3.t.79') }}</div>
              <br>
              <br>
              <ImageShow :url="P3_1"></ImageShow>
              <br>
              <br>
              <div class="step" style="font-weight: 500">{{ $t('g.p3.t.80') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.81') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.82') }}</div>
              <br>
              <br>
              <ImageShow :url="P3_2"></ImageShow>
              <br>
              <br>
              <div class="step" style="font-weight: 500">{{ $t('g.p3.t.83') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.84') }}<span class="red">{{ $t('g.p3.t.85') }}</span>{{ $t('g.p3.t.86') }}</div>
              <br>
              <br>
              <ImageShow :url="P3_3"></ImageShow>
              <br>
              <br>
              <div style="font-weight: 500">{{ $t('g.p3.t.87') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.88') }}</div>
              <br>
              <br>
              <ImageShow :url="P3_4"></ImageShow>
              <br>
              <br>
              <div>{{ $t('g.p3.t.89') }}</div>
              <br>
              <br>
              <ImageShow :url="P3_5"></ImageShow>
              <br>
              <br>
              <div style="font-weight: 500">{{ $t('g.p3.t.90') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.91') }}<span
                  style="font-weight: 500;">{{ $t('g.p3.t.92') }}</span>{{ $t('g.p3.t.93') }}<span
                  style="font-weight: 500">{{ $t('g.p3.t.94') }}</span>{{ $t('g.p3.t.95') }}<span
                  style="font-weight: 500">{{ $t('g.p3.t.96') }}</span>{{ $t('g.p3.t.97') }}
              </div>
              <br>
              <br>
              <ImageShow :url="P3_6"></ImageShow>
              <br>
              <br>
              <ImageShow :url="P3_7"></ImageShow>
              <br>
              <br>
              <div style="font-weight: 500">{{ $t('g.p3.t.98') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.99') }}</div>
              <br>
              <br>
              <ImageShow :url="P3_8"></ImageShow>
              <br>
              <br>
              <div class="step" style="font-weight: 500">{{ $t('g.p3.t.100') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.101') }}<span
                  style="font-weight: 500">{{ $t('g.p3.t.102') }}</span>{{ $t('g.p3.t.103') }}<span
                  style="font-weight: 500">{{ $t('g.p3.t.104') }}</span>{{ $t('g.p3.t.105') }}<span
                  style="font-weight: 500">{{ $t('g.p3.t.106') }}</span>{{ $t('g.p3.t.107') }}
              </div>
              <br>
              <br>
              <ImageShow :url="P3_9"></ImageShow>
              <br>
              <br>
              <div>{{ $t('g.p3.t.108') }}<span style="font-weight: 500">{{ $t('g.p3.t.109') }}</span></div>
              <br>
              <br>
              <ImageShow :url="P3_10"></ImageShow>
              <br>
              <br>
              <div>{{ $t('g.p3.t.110') }}<span
                  style="font-weight: 500;">{{ $t('g.p3.t.111') }}</span>{{ $t('g.p3.t.112') }}
              </div>
              <br>
              <br>
              <ImageShow :url="P3_11"></ImageShow>
              <br>
              <br>
              <ImageShow :url="P3_12"></ImageShow>
              <br>
              <br>
              <div class="red" style="font-weight: 500">
                {{ $t('g.p3.t.113') }}
                {{ `｛｛ ${$t('g.p3.t.113.customer')} ｝｝` }}
                {{ $t('g.p3.t.113.and') }}
                {{ `｛｛ ${$t('g.p3.t.113.name')} ｝｝` }}
                {{ $t('g.p3.t.113.next') }}
              </div>
              <br>
              <br>
              <div class="step" style="font-weight: 500">{{ $t('g.p3.t.114') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.115') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.116') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.117') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.118') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.119') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.120') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.121') }}</div>
              <br>
              <br>
              <ImageShow :url="P3_13"></ImageShow>
              <br>
              <br>
              <div class="step" style="font-weight: 500">{{ $t("g.p3.t.122") }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.123') }}</div>
              <br>
              <br>
              <div>{{ $t('g.p3.t.124') }}</div>
              <br>
              <br>
              <ImageShow :url="P3_14"></ImageShow>
              <br>
              <br>
              <div><span style="color: red">{{ $t('group.txt.tips') }}</span></div>
              <br>
              <div>{{ $t('group.txt.des') }}</div>
              <br>
              <br>
              <div style="font-weight: 500">{{ $t('group.txt.t1') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t1.1') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t1.2') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t1.3') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t1.4') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t1.5') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t1.6') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t1.7') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t1.8') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t1.9') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t1.10') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t1.11') }}</div>
              <br>
              <br>
              <div style="font-weight: 500">{{ $t('group.txt.t2') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t1.2') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t2.1') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t2.2') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t2.3') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t2.4') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t2.5') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t2.6') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t2.7') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t2.8') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t2.9') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t2.10') }}</div>
              <br>
              <br>
              <div style="font-weight: 500">{{ $t('group.txt.t3') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t3.1') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t3.2') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t3.3') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t3.4') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t3.5') }}</div>
              <br>
              <br>
              <div style="font-weight: 500">{{ $t('group.txt.t4') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t4.1') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t4.2') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t4.3') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t4.4') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t4.5') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t4.6') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t4.7') }}</div>
              <br>
              <br>
              <div style="font-weight: 500">{{ $t('group.txt.t5') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t5.1') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t5.2') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t5.3') }}</div>
              <div style="line-height: 30px;">{{ $t('group.txt.t5.4') }}</div>
              <br>
              <br>
            </CollapseItem>
          </div>
        </CollapseItem>
      </div>
      <div id="part4" style="margin-top: 30px;">
        <CollapseItem :title="$t('guide.home.part.4')" :level="1" v-model:visible="isShow4">
          <br>
          <div>{{ $t('g.p3.t.125') }}<span class="w700">{{ $t('g.p3.t.126') }}</span>{{ $t('g.p3.t.127') }}</div>
          <br>
          <ImageShow :url="docImg107"/>
          <br>
          <div id="part_child_4_1">
            <CollapseItem :title="$t('guide.home.part.4.1')" :level="2" v-model:visible="isShow4_1">
              <br>
              <div>{{ $t('guide.part.1.txt.29') }}<span class="w700">{{ $t('g.p3.t.128') }}</span>{{ $t('g.p3.t.129') }}
              </div>
              <br>
              <div>{{ $t('g.p3.t.130') }}</div>
              <br>
              <div>{{ $t('g.p3.t.131') }}<span class="w700">{{ $t('g.p3.t.132') }}</span>{{ $t('g.p3.t.133') }}<span
                  class="w700">{{ $t('g.p3.t.134') }}</span>{{ $t('g.p3.t.135') }}
              </div>
              <br>
              <ImageShow :url="docImg108"/>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_4_2">
            <CollapseItem :title="$t('guide.home.part.4.2')" :level="2" v-model:visible="isShow4_2">
              <br>
              <div>{{ $t('g.p3.t.136') }}</div>
              <br>
              <ImageShow :url="docImg109"/>
              <br>
              <ImageShow :url="docImg110"/>
              <br>
              <div>{{ $t('g.p3.t.137') }}<span class="w700">{{ $t('g.p3.t.138') }}</span>{{ $t('g.p3.t.139') }}<span
                  class="w700">{{ $t('g.p3.t.140') }}</span>{{ $t('g.p3.t.141') }}
              </div>
              <br>
              <ImageShow :url="docImg111"/>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_4_3">
            <CollapseItem :title="$t('guide.home.part.4.3')" :level="2" v-model:visible="isShow4_3">
              <br>
              <div>{{ $t('g.p3.t.142') }}</div>
              <br>
              <ImageShow :url="docImg112"/>
              <br>
              <ImageShow :url="docImg113"/>
              <br>
              <ImageShow :url="docImg114"/>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_4_4">
            <CollapseItem :title="$t('guide.home.part.4.4')" :level="2" v-model:visible="isShow4_4">
              <br>
              <div>{{ $t('g.p3.t.143') }}</div>
              <br>
              <ImageShow :url="docImg115"/>
              <br>
              <ImageShow :url="docImg116"/>
              <br>
              <div>{{ $t('g.p3.t.144') }}</div>
              <br>
              <ImageShow :url="docImg117"/>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_4_5">
            <CollapseItem :title="$t('guide.home.part.4.5')" :level="2" v-model:visible="isShow4_5">
              <br>
              <div>{{ $t('g.p3.t.145') }}<span class="w700">{{ $t('g.p3.t.146') }}</span>{{ $t('g.p3.t.147') }}</div>
              <br>
              <div>{{ $t('g.p3.t.148') }}<span class="w700">{{ $t('g.p3.t.149') }}</span>{{ $t('g.p3.t.150') }}
              </div>
              <br>
              <ImageShow :url="docImg118"/>
              <br>
              <ImageShow :url="docImg119"/>
              <br>
              <div>{{ $t('g.p3.t.151') }}</div>
              <br>
              <div>{{ $t('g.p3.t.152') }}<span class="w700">{{ $t('g.p3.t.153') }}</span>{{ $t('g.p3.t.154') }}
              </div>
              <br>
              <ImageShow :url="docImg120"/>
              <br>
              <ImageShow :url="docImg121"/>
              <br>
              <ImageShow :url="docImg122"/>
              <br>
              <br>
            </CollapseItem>
          </div>
        </CollapseItem>
      </div>
      <div id="part5" style="margin-top: 30px;">
        <CollapseItem :title="$t('guide.home.part.6')" :level="1" v-model:visible="isShow6">
          <div id="part_child_6_1">
            <CollapseItem :title="$t('guide.home.part.6.1')" :level="2" v-model:visible="isShow6_1">
              <br>
              <br>
              <div>{{ $t('guide.txt.part.6.1') }}</div>
              <br>
              <ImageShow :url="partImag6_1"/>
              <br>
              <ImageShow :url="partImag6_2"/>
              <br>
              <div>{{ $t('guide.txt.part.6.2') }}</div>
              <br>
              <ImageShow :url="partImag6_3"/>
              <br>
              <div>{{ $t('guide.txt.part.6.3') }}</div>
              <br>
              <ImageShow :url="partImag6_4"/>
              <br>
              <br>
            </CollapseItem>
          </div>
          <div id="part_child_6_2">
            <CollapseItem :title="$t('guide.home.part.6.2')" :level="2" v-model:visible="isShow6_2">
              <br>
              <br>
              <div>{{ $t('guide.txt.part.6.4') }}</div>
              <br>
              <ImageShow :url="partImag6_5"/>
              <br>
              <div>{{ $t("guide.txt.part.6.5") }}</div>
              <br>
              <ImageShow :url="partImag6_6"/>
              <br>
              <br>
            </CollapseItem>
          </div>
        </CollapseItem>
      </div>
      <div id="part6" style="margin-top: 30px;">
        <CollapseItem :title="$t('guide.home.part.5')" :level="1" v-model:visible="isShow5">
          <br>
          <br>
          <div class="step w700 ">{{ $t('g.p5.t.1') }}</div>
          <br>
          <br>
          <div>{{ $t('g.p5.t.2') }}</div>
          <br>
          <ImageShow :url="docImg123"/>
          <br>
          <br>
          <br>
          <div class="step w700 ">{{ $t('g.p5.t.3') }}</div>
          <br>
          <br>
          <div>
            {{ $t('g.p5.t.4') }}
          </div>
          <br>
          <br>
          <br>
          <div class="step w700 ">{{ $t('g.p5.t.5') }}</div>
          <br>
          <br>
          <div>{{ $t('g.p5.t.6') }}</div>
          <br>
          <br>
          <br>
          <div class="step w700 ">{{ $t('g.p5.t.7') }}</div>
          <br>
          <br>
          <div>
            {{ $t('g.p5.t.8') }}
          </div>
          <br>
          <br>
          <br>
          <div class="step w700 ">{{ $t('g.p5.t.9') }}</div>
          <br>
          <br>
          <div>
            {{ $t('g.p5.t.10') }}
          </div>
          <br>
          <ImageShow :url="docImg124"/>
          <br>
          <br>
          <br>
          <div class="step w700 ">{{ $t('g.p5.t.11') }}</div>
          <br>
          <br>
          <div>{{ $t("g.p5.t.12") }}</div>
          <br>
          <br>
          <br>
          <div class="step w700 ">{{ $t('g.p5.t.13') }}</div>
          <br>
          <br>
          <div>
            {{ $t('g.p5.t.14') }}
          </div>
          <br>
          <br>
          <br>
          <div class="step w700 ">{{ $t('g.p5.t.15') }}</div>
          <br>
          <br>
          <div>
            {{ $t('g.p5.t.16') }}
          </div>
          <br>
          <br>
          <br>
          <div class="step w700 ">{{ $t('g.p5.t.17') }}</div>
          <br>
          <br>
          <div>{{ $t("g.p5.t.18") }}</div>
          <br>
          <br>
          <br>
          <div style="font-size: 22px;" class="w700">{{ $t('g.p5.t.27') }}</div>
        </CollapseItem>
      </div>
    </template>
  </Guide>
</template>

<script setup>
import docImg1 from "@/assets/docimg/1.png";
import docImg2 from "@/assets/docimg/2.png"
import docImg3 from "@/assets/docimg/3.png"
import docImg4 from "@/assets/docimg/4.png"
import docImg5 from "@/assets/docimg/5.png"
import docImg6 from "@/assets/docimg/6.png"
import docImg7 from "@/assets/docimg/7.png"
import docImg8 from "@/assets/docimg/8.png"
import docImg9 from "@/assets/docimg/9.png"
import docImg10 from "@/assets/docimg/10.png"
import docImg11 from "@/assets/docimg/11.png"
import docImg12 from "@/assets/docimg/12.png"
import docImg13 from "@/assets/docimg/13.png"
import docImg14 from "@/assets/docimg/14.png"
import docImg15 from "@/assets/docimg/15.png"
import docImg16 from "@/assets/docimg/16.png"
import docImg17 from "@/assets/docimg/17.png"
import docImg18 from "@/assets/docimg/18.png"
import docImg19 from "@/assets/docimg/19.png"
import docImg20 from "@/assets/docimg/20.png"
import docImg21 from "@/assets/docimg/21.png"
import docImg22 from "@/assets/docimg/22.png"
import docImg23 from "@/assets/docimg/23.png"
import docImg24 from "@/assets/docimg/24.png"
//
import docImg25 from "@/assets/docimg/25.png"
import docImg26 from "@/assets/docimg/26.png"
import docImg27 from "@/assets/docimg/27.png"
import docImg28 from "@/assets/docimg/28.png"
import docImg29 from "@/assets/docimg/29.png"
import docImg30 from "@/assets/docimg/30.png"
//
import docImg31 from "@/assets/docimg/31.png"
import docImg32 from "@/assets/docimg/32.png"
//
import docImg33 from "@/assets/docimg/33.png"
import docImg34 from "@/assets/docimg/34.png"
import docImg35 from "@/assets/docimg/35.png"
import docImg36 from "@/assets/docimg/36.png"
import docImg37 from "@/assets/docimg/37.png"
//
import docImg38 from "@/assets/docimg/38.png"
import docImg39 from "@/assets/docimg/39.png"
import docImg40 from "@/assets/docimg/40.png"
import docImg41 from "@/assets/docimg/41.png"
import docImg42 from "@/assets/docimg/42.png"
import docImg43 from "@/assets/docimg/43.png"
import docImg44 from "@/assets/docimg/44.png"
import docImg45 from "@/assets/docimg/45.png"
import docImg46 from "@/assets/docimg/46.png"
import docImg47 from "@/assets/docimg/47.png"
import docImg48 from "@/assets/docimg/48.png"
import docImg49 from "@/assets/docimg/49.png"
import docImg50 from "@/assets/docimg/50.png"
import docImg51 from "@/assets/docimg/51.png"
import docImg52 from "@/assets/docimg/52.png"
import docImg53 from "@/assets/docimg/53.png"
import docImg54 from "@/assets/docimg/54.png"
import docImg55 from "@/assets/docimg/55.png"
import docImg56 from "@/assets/docimg/56.png"
import docImg57 from "@/assets/docimg/57.png"
import docImg58 from "@/assets/docimg/58.png"
import docImg59 from "@/assets/docimg/59.png"
import docImg60 from "@/assets/docimg/60.png"
import docImg61 from "@/assets/docimg/61.png"
import docImg62 from "@/assets/docimg/62.png"
import docImg63 from "@/assets/docimg/63.png"
import docImg64 from "@/assets/docimg/64.png"
import docImg65 from "@/assets/docimg/65.png"
import docImg66 from "@/assets/docimg/66.png"
import docImg67 from "@/assets/docimg/67.png"
import docImg68 from "@/assets/docimg/68.png"
import docImg69 from "@/assets/docimg/69.png"
import docImg70 from "@/assets/docimg/70.png"
import docImg71 from "@/assets/docimg/71.png"
import docImg72 from "@/assets/docimg/72.png"
import docImg73 from "@/assets/docimg/73.png"
import docImg74 from "@/assets/docimg/74.png"
import docImg75 from "@/assets/docimg/75.png"
import docImg76 from "@/assets/docimg/76.png"
import docImg77 from "@/assets/docimg/77.png"
import docImg78 from "@/assets/docimg/78.png"
import docImg79 from "@/assets/docimg/79.png"
import docImg80 from "@/assets/docimg/80.png"
import docImg81 from "@/assets/docimg/81.png"
import docImg82 from "@/assets/docimg/82.png"
import docImg83 from "@/assets/docimg/83.png"
import docImg84 from "@/assets/docimg/84.png"
import docImg85 from "@/assets/docimg/85.png"
import docImg86 from "@/assets/docimg/86.png"
import docImg87 from "@/assets/docimg/87.png"
import docImg88 from "@/assets/docimg/88.png"
import docImg89 from "@/assets/docimg/89.png"
import docImg90 from "@/assets/docimg/90.png"
import docImg91 from "@/assets/docimg/91.png"
import docImg92 from "@/assets/docimg/92.png"
import docImg93 from "@/assets/docimg/93.png"
import docImg94 from "@/assets/docimg/94.png"
import docImg95 from "@/assets/docimg/95.png"
import docImg96 from "@/assets/docimg/96.png"
import docImg97 from "@/assets/docimg/97.png"
import docImg98 from "@/assets/docimg/98.png"
import docImg99 from "@/assets/docimg/99.png"
import docImg100 from "@/assets/docimg/100.png"
import docImg101 from "@/assets/docimg/101.png"
import docImg102 from "@/assets/docimg/102.png"
import docImg103 from "@/assets/docimg/103.png"
import docImg104 from "@/assets/docimg/104.png"
import docImg105 from "@/assets/docimg/105.png"
import docImg106 from "@/assets/docimg/106.png"
import docImg107 from "@/assets/docimg/107.png"
import docImg108 from "@/assets/docimg/108.png"
import docImg109 from "@/assets/docimg/109.png"
import docImg110 from "@/assets/docimg/110.png"
import docImg111 from "@/assets/docimg/111.png"
import docImg112 from "@/assets/docimg/112.png"
import docImg113 from "@/assets/docimg/113.png"
import docImg114 from "@/assets/docimg/114.png"
import docImg115 from "@/assets/docimg/115.png"
import docImg116 from "@/assets/docimg/116.png"
import docImg117 from "@/assets/docimg/117.png"
import docImg118 from "@/assets/docimg/118.png"
import docImg119 from "@/assets/docimg/119.png"
import docImg120 from "@/assets/docimg/120.png"
import docImg121 from "@/assets/docimg/121.png"
import docImg122 from "@/assets/docimg/122.png"
import docImg123 from "@/assets/docimg/123.png"
import docImg124 from "@/assets/docimg/124.png"
import docImg125 from "@/assets/docimg/125.png"
import docImg126 from "@/assets/docimg/126.png"
// import docImg127 from "@/assets/docimg/127.png"
// import docImg128 from "@/assets/docimg/128.png"
// import docImg129 from "@/assets/docimg/129.png"
import customerTag1 from "@/assets/docimg/customer_tag_1.png"
import customerTag2 from "@/assets/docimg/customer_tag_2.png"
import customerTag3 from "@/assets/docimg/customer_tag_3.png"

import partImag6_1 from "@/assets/docimg/part_6_1.png"
import partImag6_2 from "@/assets/docimg/part_6_2.png"
import partImag6_3 from "@/assets/docimg/part_6_3.png"
import partImag6_4 from "@/assets/docimg/part_6_4.png"
import partImag6_5 from "@/assets/docimg/part_6_5.png"
import partImag6_6 from "@/assets/docimg/part_6_6.png"


import P3_1 from "@/assets/docimg/p3_1.png"
import P3_2 from "@/assets/docimg/p3_2.png"
import P3_3 from "@/assets/docimg/p3_3.png"
import P3_4 from "@/assets/docimg/p3_4.png"
import P3_5 from "@/assets/docimg/p3_5.png"
import P3_6 from "@/assets/docimg/p3_6.png"
import P3_7 from "@/assets/docimg/p3_7.png"
import P3_8 from "@/assets/docimg/p3_8.png"
import P3_9 from "@/assets/docimg/p3_9.png"
import P3_10 from "@/assets/docimg/p3_10.png"
import P3_11 from "@/assets/docimg/p3_11.png"
import P3_12 from "@/assets/docimg/p3_12.png"
import P3_13 from "@/assets/docimg/p3_13.png"
import P3_14 from "@/assets/docimg/p3_14.png"

import Guide from "@/views/FileDoc/components/Guide.vue";
import ImageShow from "@/views/FileDoc/components/ImageShow.vue";
import {onMounted, ref} from "vue";
import {useRouter} from "vue-router";
import CollapseItem from "@/views/FileDoc/components/CollapseItem.vue";
import {i18n} from "@/lang";

const router = useRouter()


const flags = true
const isShow1 = ref(flags);
const isShow1_1 = ref(flags);
const isShow1_2 = ref(flags);
const isShow1_3 = ref(flags);
const isShow1_4 = ref(flags);

const isShow2 = ref(flags)
const isShow2_1 = ref(flags)
const isShow2_2 = ref(flags)
const isShow2_3 = ref(flags)
const isShow2_4 = ref(flags)
const isShow2_5 = ref(flags)
const isShow2_6 = ref(flags)

const isShow3 = ref(flags)
const isShow3_1 = ref(flags)
const isShow3_2 = ref(flags)
const isShow3_3 = ref(flags)
const isShow3_4 = ref(flags)
const isShow3_5 = ref(flags)
const isShow3_6 = ref(flags)

const isShow4 = ref(flags);
const isShow4_1 = ref(flags)
const isShow4_2 = ref(flags)
const isShow4_3 = ref(flags)
const isShow4_4 = ref(flags)
const isShow4_5 = ref(flags)

const isShow5 = ref(flags)
const isShow6 = ref(flags)
const isShow6_1 = ref(flags)
const isShow6_2 = ref(flags)

const titleList = [
  {
    id: 1,
    title: i18n.global.t('guide.home.part.1'),
    href: "#part1",
    isExpanded: true,
    childList: [
      {
        title: i18n.global.t('guide.home.part.1.1'),
        href: "#part_child_1_1",
      },
      {
        title: i18n.global.t('guide.home.part.1.2'),
        href: "#part_child_1_2",
      },
      {
        title: i18n.global.t('guide.home.part.1.3'),
        href: "#part_child_1_3",
      },
      {
        title: i18n.global.t('guide.home.part.1.4'),
        href: "#part_child_1_4",
      },
    ]
  },
  {
    id: 2,
    title: i18n.global.t('guide.home.part.2'),
    href: "#part2",
    isExpanded: false,
    childList: [
      {title: i18n.global.t('guide.home.part.2.1'), href: "#part_child_2_1"},
      {title: i18n.global.t('guide.home.part.2.2'), href: "#part_child_2_2"},
      {title: i18n.global.t('guide.home.part.2.3'), href: "#part_child_2_3"},
      {title: i18n.global.t('guide.home.part.2.4'), href: "#part_child_2_4"},
      {title: i18n.global.t('guide.home.part.2.5'), href: "#part_child_2_5"},
      {title: i18n.global.t('guide.home.part.2.6'), href: "#part_child_2_6"},
    ]
  },
  {
    id: 3,
    title: i18n.global.t('guide.home.part.3'),
    href: "#part3",
    isExpanded: false,
    childList: [
      {title: i18n.global.t('guide.home.part.3.1'), href: "#part_child_3_1"},
      {title: i18n.global.t('guide.home.part.3.2'), href: "#part_child_3_2"},
      {title: i18n.global.t('guide.home.part.3.3'), href: "#part_child_3_3"},
      {title: i18n.global.t('guide.home.part.3.4'), href: "#part_child_3_4"},
      {title: i18n.global.t('guide.home.part.3.5'), href: "#part_child_3_5"},
      {title: i18n.global.t('guide.home.part.3.6'), href: "#part_child_3_6"},
    ]
  },
  {
    id: 4,
    title: i18n.global.t('guide.home.part.4'),
    href: "#part4",
    isExpanded: false,
    childList: [
      {title: i18n.global.t('guide.home.part.4.1'), href: "#part_child_4_1"},
      {title: i18n.global.t('guide.home.part.4.2'), href: "#part_child_4_2"},
      {title: i18n.global.t('guide.home.part.4.3'), href: "#part_child_4_3"},
      {title: i18n.global.t('guide.home.part.4.4'), href: "#part_child_4_4"},
      {title: i18n.global.t('guide.home.part.4.5'), href: "#part_child_4_5"},
    ]
  },
  {
    id: 6,
    title: i18n.global.t('guide.home.part.6'),
    href: "#part5",
    isExpanded: false,
    childList: [
      {title: i18n.global.t('guide.home.part.6.1'), href: "#part_child_6_1"},
      {title: i18n.global.t('guide.home.part.6.2'), href: "#part_child_6_2"}
    ]
  },
  {
    id: 5,
    title: i18n.global.t('guide.home.part.5'),
    href: "#part6",
    isExpanded: false,
    childList: []
  },
]

const handleClick = (e) => {
  e.preventDefault()
}
</script>
<style lang="less" scoped>
@import "../index";

:deep(.el-icon) {
  font-size: 16px !important;
}

.step {
  width: max-content;
  background: rgb(252, 231, 90);
}

.w700 {
  font-weight: 700;
}

.red {
  color: rgb(223, 42, 63);
}
</style>